module.exports = __webpack_public_path__ + "img/MainTitle.96c91671.png";